export default class HttpResponseError extends Error {
    statusCode: number;
    response: any;

    public constructor(statusCode: number, message: string, response?: any) {
        // Chiamata al costruttore della classe base `Error`
        super(message);
        this.statusCode = statusCode;
        this.response = response;

        // Impostare il nome dell'errore
        this.name = new.target.name;

        // Catturare la stack trace (utile per il debugging)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HttpResponseError);
        }
    }
}
